import { render } from "./testCom.vue?vue&type=template&id=5f5b02b5"
import script from "./testCom.vue?vue&type=script&lang=js"
export * from "./testCom.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__